// extracted by mini-css-extract-plugin
module.exports = {"root":"CompactCeil_root_13Mtt","inner":"CompactCeil_inner_gCKI_","item":"CompactCeil_item_doHTO","title":"CompactCeil_title_1X-Su"};